<template>
  <b-sidebar
    v-model="toggle"
    width="80%"
    id="sidebar-right"
    title="Product Pricing : Cost Promotion"
    backdrop-variant="dark"
    backdrop
    no-header
    right
    shadow
    @hidden="$emit('hidden')"
  >
    <template #default="{ hide }">
      <div
        class="d-flex text-light align-items-center px-3 py-2"
        style="background-color:#495057;"
      >
        <strong class="mr-auto">{{ modeAddProduct }}</strong>
        <b-button size="sm" @click="$emit('hidden')">Close</b-button>
      </div>
      <div class="px-3 py-2">
        <div class="row">
          <div class="col-12">
            <div
              class="card"
              v-if="modeAddProduct == 'Import Excel' && mode == 'new'"
            >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-row form-group">
                      <div class="col-md-12 text-right">
                        <div class="button-items">
                          <button
                            type="button"
                            class="btn btn-success"
                            @click="onDownloadTemplate"
                          >
                            Download Template
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-row form-group">
                      <label class="col-md-1 col-form-label">Upload</label>
                      <div class="col-md-6">
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span class="input-group-text bg-transparent"
                              ><i class="bx bxs-folder-open"></i
                            ></span>
                          </div>
                          <b-form-file
                            placeholder="Choose file"
                            accept=".xls, .xlsx"
                            v-on:change="importExcel($event)"
                            v-model="file"
                          ></b-form-file>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-6"></div>
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        <b-form-input
                          v-model="searchProduct"
                          type="search"
                          placeholder="Search"
                          class="form-control form-control-sm ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <b-table
                        class="table table-centered table-nowrap"
                        ref="productTable"
                        :empty-text="'ไม่พบข้อมูล'"
                        :show-empty="
                          productItems === null ||
                            productItems === undefined ||
                            (productItems && productItems.length === 0)
                        "
                        :bordered="true"
                        :filter="searchProduct"
                        :items="productItems"
                        align="center"
                        v-bind:fields="fields"
                        :perPage="pageSize"
                      >
                        <template v-slot:cell(index)="data">
                          <div class="text-right">
                            {{ (firstRowOnPage + data.index) | number }}
                          </div>
                        </template>
                        <template v-slot:cell(inventory_status)="data">
                          <span
                            v-if="data.value"
                            class="label"
                            :class="'label-' + data.value.toLowerCase()"
                            v-html="data.value"
                          ></span>
                        </template>
                        <template
                          v-slot:cell(cost_promotion_exclude_vat)="data"
                        >
                          <input
                            v-model="
                              productItems[data.index]
                                .cost_promotion_exclude_vat
                            "
                            type="number"
                            class="form-control form-default text-right"
                          />
                        </template>
                        <template v-slot:cell(promotion_start_date)="data">
                          <input
                            v-model="
                              productItems[data.index].promotion_start_date
                            "
                            type="datetime-local"
                            class="form-control"
                            v-on:change="onChangeProductItems(data.index)"
                          />
                        </template>
                        <template v-slot:cell(promotion_end_date)="data">
                          <input
                            v-model="
                              productItems[data.index].promotion_end_date
                            "
                            type="datetime-local"
                            class="form-control"
                            v-on:change="onChangeProductItems(data.index)"
                          />
                        </template>
                        <template v-slot:cell(product_remark)="data">
                          <input
                            v-model="productItems[data.index].product_remark"
                            type="text"
                            class="form-control form-default text-left"
                          />
                        </template>
                        <template v-slot:cell(action)="data">
                          <div class="text-center">
                            <a
                              @click="onDeleteProduct(data.item.id)"
                              class="btn btn-ico text-danger"
                              ><i class="bx bx-trash"></i
                            ></a>
                          </div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-4 text-center">
                  <div class="button-items">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="onSave()"
                    >
                      Apply
                    </button>
                    <button
                      v-if="
                        productItems &&
                          productItems.some(s => s.is_error == true)
                      "
                      type="button"
                      class="btn btn-danger"
                      @click="onClearRowDataError()"
                    >
                      Clear Error
                    </button>
                    <button
                      type="button"
                      class="btn btn-light waves-effect"
                      @click="onClear()"
                    >
                      <i class="bx bx-reset" />
                      Clear
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="$emit('hidden')"
                    >
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="card"
              v-if="modeAddProduct == 'Condition' && mode == 'edit'"
            >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-row form-group">
                      <label class="col-md-2 col-form-label">สินค้า</label>
                      <div class="col-md-9">
                        <input
                          v-model="filter.keyword"
                          type="text"
                          placeholder="รหัสกลุ่มสินค้า / รหัสสินค้า / ชื่อสินค้า"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-row form-group">
                      <label class="col-md-2 col-form-label"
                        >วันที่ Promotion</label
                      >
                      <div class="col-md-4">
                        <input
                          v-model="filter.promotion_start_date"
                          type="datetime-local"
                          class="form-control"
                        />
                      </div>
                      <label class="col-md-1 col-form-label text-center"
                        >ถึง</label
                      >
                      <div class="col-md-4">
                        <input
                          v-model="filter.promotion_end_date"
                          type="datetime-local"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6"></div>
                  <div class="col-lg-6 text-sm-right">
                    <div class="button-items">
                      <button
                        type="button"
                        class="btn btn-primary waves-effect"
                        @click="onFilterCondition()"
                      >
                        <i
                          class="bx bx-search font-size-16 align-middle mr-2"
                        ></i>
                        Search
                      </button>
                      <button
                        type="button"
                        class="btn btn-light waves-effect"
                        @click="onClearCondition()"
                      >
                        <i
                          class="bx bx-reset font-size-16 align-middle mr-2"
                        ></i>
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
                <br />
                <div class="row">
                  <div class="col-sm-12 col-md-6"></div>
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        <b-form-input
                          v-model="searchProductCondition"
                          type="search"
                          placeholder="Search"
                          class="form-control form-control-sm ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <b-table
                        class="table table-centered table-nowrap"
                        ref="productTable"
                        :empty-text="'ไม่พบข้อมูล'"
                        :show-empty="
                          productItems === null ||
                            productItems === undefined ||
                            (productItems && productItems.length === 0)
                        "
                        :bordered="true"
                        :filter="searchProductCondition"
                        :items="productItems"
                        align="center"
                        v-bind:fields="fieldsCondition"
                        :perPage="pageSize"
                      >
                        <template v-slot:cell(index)="data">
                          <div class="text-right">
                            {{ (firstRowOnPage + data.index) | number }}
                          </div>
                        </template>
                        <template v-slot:cell(inventory_status)="data">
                          <span
                            v-if="data.value"
                            class="label"
                            :class="'label-' + data.value.toLowerCase()"
                            v-html="data.value"
                          ></span>
                        </template>
                        <template
                          v-slot:cell(cost_promotion_exclude_vat)="data"
                        >
                          <input
                            v-if="
                              productItems[data.index].promotion_status !=
                                'Complete' &&
                                productItems[data.index].promotion_status !=
                                  'Delete' &&
                                productItems[data.index].promotion_status !=
                                  'Expire'
                            "
                            v-model="
                              productItems[data.index]
                                .cost_promotion_exclude_vat
                            "
                            type="number"
                            class="form-control form-default text-right"
                          />
                          <span v-else>{{
                            productItems[data.index].cost_promotion_exclude_vat
                          }}</span>
                        </template>
                        <template v-slot:cell(promotion_start_date)="data">
                          <input
                            v-if="
                              productItems[data.index].promotion_status !=
                                'Complete' &&
                                productItems[data.index].promotion_status !=
                                  'Delete' &&
                                productItems[data.index].promotion_status !=
                                  'Expire'
                            "
                            v-model="
                              productItems[data.index].promotion_start_date
                            "
                            type="datetime-local"
                            class="form-control"
                            v-on:change="onChangeProductItems(data.index)"
                          />
                          <span v-else>{{
                            FormatDateTime(
                              productItems[data.index].promotion_start_date
                            )
                          }}</span>
                        </template>
                        <template v-slot:cell(promotion_end_date)="data">
                          <input
                            v-if="
                              productItems[data.index].promotion_status !=
                                'Delete' &&
                                productItems[data.index].promotion_status !=
                                  'Expire'
                            "
                            v-model="
                              productItems[data.index].promotion_end_date
                            "
                            type="datetime-local"
                            class="form-control"
                            v-on:change="onChangeProductItems(data.index)"
                          />
                          <span v-else>{{
                            FormatDateTime(
                              productItems[data.index].promotion_end_date
                            )
                          }}</span>
                        </template>
                        <template v-slot:cell(product_remark)="data">
                          <input
                            v-if="
                              productItems[data.index].promotion_status !=
                                'Complete' &&
                                productItems[data.index].promotion_status !=
                                  'Delete' &&
                                productItems[data.index].promotion_status !=
                                  'Expire'
                            "
                            v-model="productItems[data.index].product_remark"
                            type="text"
                            class="form-control form-default text-left"
                          />
                          <span v-else>{{
                            productItems[data.index].product_remark
                          }}</span>
                        </template>
                        <template v-slot:cell(promotion_status)="data">
                          <basic-select
                            v-if="
                              productItems[data.index].promotion_status !=
                                'Expire'
                            "
                            :options="optionsStatus"
                            :reload="reloadPromotionStatusSelector"
                            :selected-option="{
                              text: productItems[data.index].promotion_status,
                              value: productItems[data.index].promotion_status,
                            }"
                            @select="
                              onPromotionStatusSelectorInConditionList(
                                $event,
                                data.index
                              )
                            "
                            placeholder="เลือกสถานะ"
                          >
                          </basic-select>
                          <span v-else>{{
                            productItems[data.index].promotion_status
                          }}</span>
                        </template>
                        <template v-slot:cell(action)="data">
                          <div class="text-center">
                            <a
                              @click="onDeleteProduct(data.item.id)"
                              class="btn btn-ico text-danger"
                              ><i class="bx bx-trash"></i
                            ></a>
                          </div>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-4 text-center">
                  <div class="button-items">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="onSave()"
                    >
                      Apply
                    </button>
                    <button
                      v-if="
                        productItems &&
                          productItems.some(s => s.is_error == true)
                      "
                      type="button"
                      class="btn btn-danger"
                      @click="onClearRowDataError()"
                    >
                      Clear Error
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="onClear()"
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="$emit('hidden')"
                    >
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card" v-if="modeAddProduct === 'Add Product'">
              <div class="card-body">
                <validationObserver ref="createView">
                  <validationProvider
                    v-slot="{ errors }"
                    name="SKU CODE OFM"
                    :rules="{
                      dynamicRequired: ['กรุณาระบุรหัสสินค้า (OFM)'],
                    }"
                  >
                    <div class="form-row form-group">
                      <label class="col-sm-2 col-form-label"
                        >รหัสสินค้า (OFM)</label
                      >
                      <div class="col-sm-4">
                        <input
                          id="input_sku_code_ofm"
                          name="input_sku_code_ofm"
                          type="text"
                          class="form-control"
                          v-model="model.sku_code_ofm"
                          :class="{
                            'is-invalid': errors && errors.length,
                            'is-valid':
                              !(errors && errors.length) && model.sku_code_ofm,
                          }"
                          v-on:keyup.enter="onFilter()"
                        />
                        <div
                          v-if="errors && errors.length"
                          class="validate-invalid"
                        >
                          <span>{{ errors[0] }}</span>
                        </div>
                      </div>
                    </div>
                  </validationProvider>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label"
                      >รหัสกลุ่มสินค้า</label
                    >
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.product_id"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label">ชื่อสินค้า</label>
                    <div class="col-sm-6">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.product_display_name.th"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label">ประเภทผู้ขาย</label>
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.vendor_type"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label">สถานะสินค้า</label>
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.inventory_status"
                        readonly
                      />
                    </div>
                    <label class="col-sm-2 col-form-label">สถานะการขาย</label>
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.sale_status"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label">หน่วยสินค้า</label>
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.unit.display_name.th"
                        readonly
                      />
                    </div>
                    <label class="col-sm-2 col-form-label">Ratio</label>
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.unit.ratio"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label"
                      >สินค้าคิดภาษี (Vat)</label
                    >
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.is_vat"
                        readonly
                      />
                    </div>
                  </div>
                  <br />
                  <br />
                  <h4 class="card-title mb-4">Gross Profit Margin</h4>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label"
                      >GP Standard (%)</label
                    >
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.gp_standard"
                        readonly
                      />
                    </div>
                    <label class="col-sm-2 col-form-label"
                      >Commission Rate (%)</label
                    >
                    <div class="col-sm-4">
                      <input
                        type="number"
                        class="form-control"
                        v-model="model.commission_rate"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label">GP Rate (%)</label>
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.gp_rate"
                        readonly
                      />
                    </div>
                    <label class="col-sm-2 col-form-label">GP Amount</label>
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.gp_amount"
                        readonly
                      />
                    </div>
                  </div>
                  <br />
                  <br />
                  <h4 class="card-title mb-4">Cost</h4>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label"
                      >ส่วนลดในตัว (%)</label
                    >
                    <div class="col-sm-4">
                      <input
                        type="number"
                        class="form-control"
                        v-model="model.discount_rate"
                        readonly
                      />
                    </div>
                    <label class="col-sm-2 col-form-label"
                      >ส่วนลดท้ายบิล (%)</label
                    >
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.supplier_discount_rate"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label"
                      >ราคาทุนหน่วยซื้อ <br />(Excluding Vat)</label
                    >
                    <div class="col-sm-4">
                      <input
                        type="number"
                        class="form-control"
                        v-model="model.cost_exclude_vat"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label"
                      >ราคาทุนขาย <br />(Excluding Vat)</label
                    >
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.cost_of_sale"
                        readonly
                      />
                    </div>
                  </div>
                  <br />
                  <br />
                  <h4 class="card-title mb-4">Sale Price</h4>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label"
                      >ราคาแนะนำขาย <br />(Including Vat)</label
                    >
                    <div class="col-sm-4">
                      <input
                        type="number"
                        class="form-control"
                        v-model="model.retail_price_include_vat"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label"
                      >ราคาขาย <br />(Including Vat)</label
                    >

                    <div class="col-sm-4">
                      <input
                        type="number"
                        class="form-control"
                        v-model="model.sale_price_include_vat"
                        readonly
                      />
                    </div>
                    <label class="col-sm-2 col-form-label"
                      >ราคาขาย <br />(Excluding Vat)</label
                    >
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.sale_price_exclude_vat"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label">MR Point</label>
                    <div class="col-sm-4">
                      <input
                        type="text"
                        class="form-control"
                        v-model="model.mr_point"
                        readonly
                      />
                    </div>
                  </div>
                  <br />
                  <br />
                  <h4 class="card-title mb-4">Cost Promotion</h4>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label"
                      >วันที่เริ่มต้น</label
                    >
                    <div class="col-sm-4">
                      <input
                        type="datetime-local"
                        class="form-control"
                        v-model="model.promotion_start_date"
                        v-on:change="onCheckExistProductCostPromotion()"
                      />
                    </div>
                    <label class="col-sm-2 col-form-label">วันที่สิ้นสุด</label>
                    <div class="col-sm-4">
                      <input
                        type="datetime-local"
                        class="form-control"
                        v-model="model.promotion_end_date"
                        v-on:change="onCheckExistProductCostPromotion()"
                      />
                    </div>
                  </div>
                  <validationProvider
                    v-slot="{ errors }"
                    name="Cost Promotion Exclude Vat"
                    :rules="{
                      dynamicRequired: ['กรุณาระบุราคาทุน Promotion'],
                    }"
                  >
                    <div class="form-row form-group">
                      <label class="col-sm-2 col-form-label"
                        >ราคาทุน Promotion<br />(Excluding Vat)</label
                      >
                      <div class="col-sm-4">
                        <input
                          id="input_cost_promotion_exclude_vat"
                          name="input_cost_promotion_exclude_vat"
                          type="number"
                          class="form-control"
                          v-model="model.cost_promotion_exclude_vat"
                          :class="{
                            'is-invalid': errors && errors.length,
                            'is-valid':
                              !(errors && errors.length) &&
                              model.cost_promotion_exclude_vat,
                          }"
                        />
                        <div
                          v-if="errors && errors.length"
                          class="validate-invalid"
                        >
                          <span>{{ errors[0] }}</span>
                        </div>
                      </div>
                    </div>
                  </validationProvider>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label"
                      >สถานะ Promotion</label
                    >
                    <div class="col-sm-4">
                      <basic-select
                        :options="optionsStatus"
                        :reload="reloadPromotionStatusSelector"
                        :selected-option="{
                          text: model.promotion_status,
                          value: model.promotion_status,
                        }"
                        @select="onPromotionStatusSelector($event)"
                        placeholder="เลือกสถานะ"
                        v-bind:isError="isValidate.promotion_status"
                      >
                      </basic-select>
                    </div>
                  </div>
                  <div class="form-row form-group">
                    <label class="col-sm-2 col-form-label"
                      >หมายเหตุการปรับราคา</label
                    >
                    <div class="col-sm-8">
                      <textarea
                        v-model="model.product_remark"
                        class="form-control"
                        rows="3"
                      ></textarea>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 text-sm-right">
                      <div class="button-items">
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="onSave()"
                        >
                          Apply
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary"
                          @click="onClearAddProduct()"
                        >
                          Clear
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary"
                          @click="$emit('hidden')"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </div>
                </validationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>
<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import { FormatDate, FormatDateTime } from '@/helpers/utils/format-date.js'
import productCostPromotionService from '@/helpers/service/product-cost-promotion-service'
import { eventBus } from '@/main.js'
import { StatusEnum } from '@/enum/status.enum.js'
import XLSX from 'xlsx'
import downloadexcel from 'vue-json-excel'
import Swal from 'sweetalert2'
import moment from 'moment'
import { BasicSelect } from 'vue-search-select'

export default {
  components: { 'basic-select': BasicSelect },
  props: {
    toggleSideBar: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: '',
    },
    modeAddProduct: {
      type: String,
      default: '',
    },
    listProductItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      file: null,
      optionsStatus: [
        { text: StatusEnum.ACTIVE, value: StatusEnum.ACTIVE },
        { text: StatusEnum.DELETE, value: StatusEnum.DELETE },
      ],
      reloadPromotionStatusSelector: false,
      isValidate: {
        promotion_status: false,
        promotion_date: false,
      },
      exportData: [
        {
          'รหัสสินค้า (OFM)': '',
          'ราคาทุนโปรโมชั่น ExVat': '',
          วันที่เริ่มต้น: '',
          วันที่สิ้นสุด: '',
          หมายเหตุการปรับราคาทุนโปรโมชั่น: '',
        },
      ],
      templateName: 'TemplateEditProductCostPromotion.xlsx',
      toggle: false,
      searchProduct: null,
      searchProductCondition: null,
      firstRowOnPage: 1,
      pageSize: 99999,
      pageNo: 1,
      productItems: [],
      model: {
        id: null,
        product_sku_promotion_price_id: null,
        sku_code_ofm: null,
        product_id: null,
        product_display_name: {
          th: null,
          en: null,
        },
        unit: {
          display_name: {
            th: null,
            en: null,
          },
          ratio: null,
        },
        inventory_status: null,
        sale_status: null,
        is_vat: null,
        discount_rate: null,
        supplier_discount_rate: null,
        cost_exclude_vat: null,
        cost_of_sale: null,
        sale_price_include_vat: null,
        sale_price_exclude_vat: null,
        retail_price_include_vat: null,
        mr_point: null,
        gp_rate: null,
        gp_amount: null,
        gp_standard: null,
        commission_rate: null,
        product_remark: null,
        vendor_type: null,
        cost_promotion_exclude_vat: null,
        promotion_start_date: moment()
          .startOf('day')
          .format('YYYY-MM-DDTHH:mm'),
        promotion_end_date: moment()
          .endOf('day')
          .format('YYYY-MM-DDTHH:mm'),
        promotion_status: StatusEnum.ACTIVE,
      },
      filter: {
        keyword: '',
        promotion_start_date: '',
        promotion_end_date: '',
      },
      fields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'product_id',
          label: 'รหัสกลุ่มสินค้า',
          sortable: true,
        },
        {
          key: 'sku_code_ofm',
          label: 'รหัสสินค้า (OFM)',
          sortable: true,
        },
        {
          key: 'product_display_name.th',
          label: 'ชื่อสินค้า',
          sortable: true,
        },
        {
          key: 'inventory_status',
          label: 'สถานะสินค้า',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'cost_exclude_vat',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ราคาทุนหน่วยซื้อ (Excluding Vat)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'cost_promotion_exclude_vat',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ราคาทุน Promotion (Excluding Vat)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'promotion_start_date',
          label: 'วันและเวลาเริ่มต้น',
          formatter: (value, key, item) => {
            return FormatDateTime(value)
          },
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'promotion_end_date',
          label: 'วันและเวลาสิ้นสุด',
          formatter: (value, key, item) => {
            return FormatDateTime(value)
          },
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'product_remark',
          label: 'หมายเหตุการปรับราคา',
          tdClass: 'text-left',
        },
        {
          key: 'error_message',
          label: 'Error Message',
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
      fieldsCondition: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'product_id',
          label: 'รหัสกลุ่มสินค้า',
          sortable: true,
        },
        {
          key: 'sku_code_ofm',
          label: 'รหัสสินค้า (OFM)',
          sortable: true,
        },
        {
          key: 'product_display_name.th',
          label: 'ชื่อสินค้า',
          sortable: true,
        },
        {
          key: 'inventory_status',
          label: 'สถานะสินค้า',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'cost_exclude_vat',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ราคาทุนหน่วยซื้อ (Excluding Vat)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'cost_promotion_exclude_vat',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ราคาทุน Promotion (Excluding Vat)',
          sortable: true,
          tdClass: 'text-right',
        },
        {
          key: 'promotion_start_date',
          label: 'วันและเวลาเริ่มต้น',
          formatter: (value, key, item) => {
            return FormatDateTime(value)
          },
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'promotion_end_date',
          label: 'วันและเวลาสิ้นสุด',
          formatter: (value, key, item) => {
            return FormatDateTime(value)
          },
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'promotion_status',
          label: 'สถานะ Promotion',
          thStyle: 'width:120px',
          sortable: true,
          tdClass: 'text-center',
        },
        {
          key: 'product_remark',
          label: 'หมายเหตุการปรับราคา',
          tdClass: 'text-left',
        },
        {
          key: 'error_message',
          label: 'Error Message',
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
      today: moment().format('YYYY-MM-DDTHH:mm'),
    }
  },
  computed: {},
  watch: {
    toggleSideBar: function(value) {
      this.toggle = value
      this.onClear()
      this.onClearAddProduct()
      this.onClearCondition()
    },
    productItems: {
      handler: function(val) {
        val.forEach(element => {
          if (element.is_error) {
            element._rowVariant = 'danger'
          } else {
            element._rowVariant = ''
          }
        })
      },
      deep: true,
    },
  },
  mounted: function() {},
  methods: {
    async onChangeProductItems(index) {
      if (
        this.productItems[index].promotion_start_date !== null &&
        this.productItems[index].promotion_start_date !== undefined &&
        this.productItems[index].promotion_start_date <
          moment(new Date()).format('YYYY-MM-DDThh:mm')
      ) {
        this.productItems[index].is_error = true
        this.productItems[index].error_message =
          'วันที่เริ่มน้อยกว่าวันที่ปัจจุบัน ไม่สามารถทำรายการได้'
      } else if (
        this.productItems[index].promotion_end_date !== null &&
        this.productItems[index].promotion_end_date !== undefined &&
        this.productItems[index].promotion_end_date <
          moment(new Date()).format('YYYY-MM-DDThh:mm')
      ) {
        this.productItems[index].is_error = true
        this.productItems[index].error_message =
          'วันที่สิ้นสุดน้อยกว่าวันที่ปัจจุบัน ไม่สามารถทำรายการได้'
      } else if (
        this.productItems[index].promotion_start_date !== null &&
        this.productItems[index].promotion_start_date !== undefined &&
        this.productItems[index].promotion_end_date !== null &&
        this.productItems[index].promotion_end_date !== undefined &&
        this.productItems[index].promotion_start_date >
          this.productItems[index].promotion_end_date
      ) {
        this.productItems[index].is_error = true
        this.productItems[index].error_message =
          'วันที่เริ่มมากกว่าวันที่สิ้นสุด ไม่สามารถทำรายการได้'
      } else if (
        this.productItems[index].promotion_start_date !== null &&
        this.productItems[index].promotion_start_date !== undefined &&
        this.productItems[index].promotion_end_date !== null &&
        this.productItems[index].promotion_end_date !== undefined
      ) {
        let params = new URLSearchParams()
        params.append('sku_id', this.productItems[index].id)
        if (this.mode == 'edit') {
          params.append(
            'product_sku_promotion_price_id',
            this.productItems[index].product_sku_promotion_price_id
          )
        }
        params.append('mode', this.mode)
        params.append(
          'promotion_start_date',
          this.productItems[index].promotion_start_date
        )
        params.append(
          'promotion_end_date',
          this.productItems[index].promotion_end_date
        )

        let result = await productCostPromotionService.headProductCostPromotionAsync(
          params
        )
        if (result.status === 200) {
          this.productItems[index].is_error = true
          this.productItems[index].error_message =
            'มีการกำหนดราคาทุนโปรโมชั่นในช่วงเวลานี้ในระบบแล้ว'
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.productItems[index].is_error = false
          this.productItems[index].error_message = ''
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      } else {
        this.productItems[index].is_error = false
        this.productItems[index].error_message = ''
      }

      if (this.productItems[index].is_error) {
        this.productItems[index]._rowVariant = 'danger'
      } else {
        this.productItems[index]._rowVariant = ''
      }
    },
    async onFilter() {
      if (this.model.sku_code_ofm) {
        this.productItems = []
        let params = new URLSearchParams()
        params.append('sku_code_ofm', this.model.sku_code_ofm)
        params.append('mode', this.mode)

        let result = await productCostPromotionService.getProductCostPromotionBySkuCodeAsync(
          params
        )
        if (result.status === 200 || result.status === 201) {
          this.model = result.data
          if (this.mode == 'new') {
            this.model.promotion_start_date = moment()
              .startOf('day')
              .format('YYYY-MM-DDTHH:mm')
            this.model.promotion_end_date = moment()
              .endOf('day')
              .format('YYYY-MM-DDTHH:mm')
          } else {
            this.model.promotion_start_date = moment(
              this.model.promotion_start_date
            ).format('YYYY-MM-DDTHH:mm')
            this.model.promotion_end_date = moment(
              this.model.promotion_end_date
            ).format('YYYY-MM-DDTHH:mm')
          }
          // this.productItems.push(result.data)
        } else if (result.status === 404) {
          this.$utils.notification(
            'error',
            'ไม่พบข้อมูลของสินค้า (รหัสสินค้านี้ไม่มีข้อมูล) ในระบบ',
            3000
          )
        } else {
          this.$utils.notification('error', result.response.data.message, 2000)
        }
      }
    },
    async onUpload(value) {
      this.productItems = []
      value.forEach(element => {
        element.promotion_start_date = moment(
          element.promotion_start_date
        ).format('YYYY-MM-DDTHH:mm')
        element.promotion_end_date = moment(element.promotion_end_date).format(
          'YYYY-MM-DDTHH:mm'
        )
      })
      let result = await productCostPromotionService.SearchProductSkuIncludeProductPriceAsync(
        value
      )

      if (result.status === 200 || result.status === 201) {
        this.productItems = result.data
        this.productItems.forEach(element => {
          element.promotion_start_date = moment(
            element.promotion_start_date
          ).format('YYYY-MM-DDTHH:mm')

          element.promotion_end_date = moment(
            element.promotion_end_date
          ).format('YYYY-MM-DDTHH:mm')
        })
      } else if (result.status === 404) {
        this.$utils.notification(
          'error',
          'ไม่พบข้อมูลของสินค้า (รหัสสินค้านี้ไม่มีข้อมูล) ในระบบ',
          3000
        )
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onFilterCondition() {
      this.productItems = []
      let params = new URLSearchParams()
      params.append('keyword', this.filter.keyword)
      params.append('promotion_start_date', this.filter.promotion_start_date)
      params.append('promotion_end_date', this.filter.promotion_end_date)
      params.append('sort', 'product_id')
      let result = await productCostPromotionService.getProductCostPromotionByCondition(
        params
      )
      if (result.status === 200 || result.status === 201) {
        this.productItems = result.data
        this.productItems.forEach(element => {
          element.promotion_start_date = moment(
            element.promotion_start_date
          ).format('YYYY-MM-DDTHH:mm')

          element.promotion_end_date = moment(
            element.promotion_end_date
          ).format('YYYY-MM-DDTHH:mm')
        })
      } else if (result.status === 404) {
        this.$utils.notification(
          'error',
          'ไม่พบข้อมูลของสินค้า (รหัสสินค้านี้ไม่มีข้อมูล) ในระบบ',
          3000
        )
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onSave() {
      if (
        this.modeAddProduct === 'Import Excel' ||
        this.modeAddProduct === 'Condition'
      ) {
        if (this.productItems.length === 0) {
          this.$utils.notification(
            'error',
            'ไม่มีรายการสินค้าให้ Add เพิ่ม',
            3000
          )
        } else if (this.productItems.some(s => s.is_error == true)) {
          this.$utils.notification(
            'error',
            'ไม่สามารถดำเนินการต่อได้เนื่องจากชุดยังมูลยังมีรายการที่ผิดพลาด',
            3000
          )
        } else {
          let checkExist = false
          if (this.listProductItems.length > 0) {
            this.productItems.forEach(element => {
              if (
                this.listProductItems.find(
                  f =>
                    f.id === element.id &&
                    ((element.promotion_start_date <= f.promotion_start_date &&
                      element.promotion_end_date <= f.promotion_end_date &&
                      element.promotion_end_date > f.promotion_start_date) ||
                      (element.promotion_start_date >= f.promotion_start_date &&
                        element.promotion_end_date >= f.promotion_end_date &&
                        element.promotion_start_date < f.promotion_end_date) ||
                      (element.promotion_start_date >= f.promotion_start_date &&
                        element.promotion_end_date <= f.promotion_end_date) ||
                      (element.promotion_start_date <= f.promotion_start_date &&
                        element.promotion_end_date >= f.promotion_end_date))
                ) !== undefined
              ) {
                checkExist = true
              }
            })
            if (checkExist) {
              this.$utils.notification(
                'error',
                'มีการกำหนดราคาทุนโปรโมชั่นในช่วงเวลานี้ในระบบแล้ว',
                3000
              )
            } else {
              if (
                this.productItems.some(s => s.cost_promotion_exclude_vat == '0')
              ) {
                await this.$utils
                  .confirmAlertDisplay(
                    `ราคาทุนโปรโมชั่นเท่ากับ 0 ต้องการทำรายการหรือไม่`,
                    ''
                  )
                  .then(result => {
                    if (result) {
                      this.$emit('hidden')
                      this.$emit('getDataSideBar', this.productItems)
                    }
                  })
              } else if (
                this.productItems.some(
                  s => s.cost_promotion_exclude_vat > s.cost_exclude_vat
                )
              ) {
                await this.$utils
                  .confirmAlertDisplay(
                    `ราคาทุนโปรโมชั่นมากกว่าราคาทุนปกติ ต้องการทำรายการหรือไม่`,
                    ''
                  )
                  .then(result => {
                    if (result) {
                      this.$emit('hidden')
                      this.$emit('getDataSideBar', this.productItems)
                    }
                  })
              } else {
                this.$emit('hidden')
                this.$emit('getDataSideBar', this.productItems)
              }
            }
          } else {
            if (
              this.productItems.some(s => s.cost_promotion_exclude_vat == '0')
            ) {
              await this.$utils
                .confirmAlertDisplay(
                  `ราคาทุนโปรโมชั่นเท่ากับ 0 ต้องการทำรายการหรือไม่`,
                  ''
                )
                .then(result => {
                  if (result) {
                    this.$emit('hidden')
                    this.$emit('getDataSideBar', this.productItems)
                  }
                })
            } else if (
              this.productItems.some(
                s => s.cost_promotion_exclude_vat > s.cost_exclude_vat
              )
            ) {
              await this.$utils
                .confirmAlertDisplay(
                  `ราคาทุนโปรโมชั่นมากกว่าราคาทุนปกติ ต้องการทำรายการหรือไม่`,
                  ''
                )
                .then(result => {
                  if (result) {
                    this.$emit('hidden')
                    this.$emit('getDataSideBar', this.productItems)
                  }
                })
            } else {
              this.$emit('hidden')
              this.$emit('getDataSideBar', this.productItems)
            }
          }
        }
      } else {
        this.$refs.createView.validate().then(async response => {
          if (response) {
            this.productItems = []
            if (
              this.model.sku_code_ofm === null ||
              this.model.sku_code_ofm === undefined ||
              this.model.sku_code_ofm === ''
            ) {
              this.$utils.notification(
                'error',
                'ไม่มีรายการสินค้าให้ Add เพิ่ม',
                3000
              )
            } else if (
              this.model.promotion_start_date > this.model.promotion_end_date
            ) {
              this.$utils.notification(
                'error',
                'วันที่เริ่มมากกว่าวันที่สิ้นสุด ไม่สามารถทำรายการได้',
                3000
              )
            } else if (this.model.promotion_start_date < this.today) {
              this.$utils.notification(
                'error',
                'วันที่เริ่มน้อยกว่าวันที่ปัจจุบัน ไม่สามารถทำรายการได้',
                3000
              )
            } else if (this.model.promotion_end_date < this.today) {
              this.$utils.notification(
                'error',
                'วันที่สิ้นสุดน้อยกว่าวันที่ปัจจุบันไม่สามารถทำรายการได้',
                3000
              )
            } else if (this.isValidate.promotion_date) {
              this.$utils.notification(
                'error',
                'มีการกำหนดราคาทุนโปรโมชั่นในช่วงเวลานี้ในระบบแล้ว',
                3000
              )
            } else {
              let checkExist = false
              this.productItems.push(this.model)
              if (this.listProductItems.length > 0) {
                this.productItems.forEach(element => {
                  if (
                    this.listProductItems.find(
                      f =>
                        f.id === element.id &&
                        ((element.promotion_start_date <=
                          f.promotion_start_date &&
                          element.promotion_end_date <= f.promotion_end_date &&
                          element.promotion_end_date >
                            f.promotion_start_date) ||
                          (element.promotion_start_date >=
                            f.promotion_start_date &&
                            element.promotion_end_date >=
                              f.promotion_end_date &&
                            element.promotion_start_date <
                              f.promotion_end_date) ||
                          (element.promotion_start_date >=
                            f.promotion_start_date &&
                            element.promotion_end_date <=
                              f.promotion_end_date) ||
                          (element.promotion_start_date <=
                            f.promotion_start_date &&
                            element.promotion_end_date >= f.promotion_end_date))
                    ) !== undefined
                  ) {
                    checkExist = true
                  }
                })
                if (checkExist) {
                  this.$utils.notification(
                    'error',
                    'มีการกำหนดราคาทุนโปรโมชั่นในช่วงเวลานี้ในระบบแล้ว',
                    3000
                  )
                } else {
                  if (
                    this.productItems.some(
                      s => s.cost_promotion_exclude_vat == '0'
                    )
                  ) {
                    await this.$utils
                      .confirmAlertDisplay(
                        `ราคาทุนโปรโมชั่นเท่ากับ 0 ต้องการทำรายการหรือไม่`,
                        ''
                      )
                      .then(result => {
                        if (result) {
                          this.$emit('hidden')
                          this.$emit('getDataSideBar', this.productItems)
                        }
                      })
                  } else if (
                    this.productItems.some(
                      s => s.cost_promotion_exclude_vat > s.cost_exclude_vat
                    )
                  ) {
                    await this.$utils
                      .confirmAlertDisplay(
                        `ราคาทุนโปรโมชั่นมากกว่าราคาทุนปกติ ต้องการทำรายการหรือไม่`,
                        ''
                      )
                      .then(result => {
                        if (result) {
                          this.$emit('hidden')
                          this.$emit('getDataSideBar', this.productItems)
                        }
                      })
                  } else {
                    this.$emit('hidden')
                    this.$emit('getDataSideBar', this.productItems)
                  }
                }
              } else {
                if (
                  this.productItems.some(
                    s => s.cost_promotion_exclude_vat == '0'
                  )
                ) {
                  await this.$utils
                    .confirmAlertDisplay(
                      `ราคาทุนโปรโมชั่นเท่ากับ 0 ต้องการทำรายการหรือไม่`,
                      ''
                    )
                    .then(result => {
                      if (result) {
                        this.$emit('hidden')
                        this.$emit('getDataSideBar', this.productItems)
                      }
                    })
                } else if (
                  this.productItems.some(
                    s => s.cost_promotion_exclude_vat > s.cost_exclude_vat
                  )
                ) {
                  await this.$utils
                    .confirmAlertDisplay(
                      `ราคาทุนโปรโมชั่นมากกว่าราคาทุนปกติ ต้องการทำรายการหรือไม่`,
                      ''
                    )
                    .then(result => {
                      if (result) {
                        this.$emit('hidden')
                        this.$emit('getDataSideBar', this.productItems)
                      }
                    })
                } else {
                  this.$emit('hidden')
                  this.$emit('getDataSideBar', this.productItems)
                }
              }
            }
          }
        })
      }
    },
    onClear() {
      this.file = null
      this.searchProduct = null
      this.searchProductCondition = null
      this.productItems = []
    },
    onClearAddProduct() {
      this.model = {
        id: null,
        product_sku_promotion_price_id: null,
        sku_code_ofm: null,
        product_id: null,
        product_display_name: {
          th: null,
          en: null,
        },
        unit: {
          display_name: {
            th: null,
            en: null,
          },
          ratio: null,
        },
        inventory_status: null,
        sale_status: null,
        is_vat: null,
        discount_rate: null,
        supplier_discount_rate: null,
        cost_exclude_vat: null,
        cost_of_sale: null,
        sale_price_include_vat: null,
        sale_price_exclude_vat: null,
        retail_price_include_vat: null,
        mr_point: null,
        gp_rate: null,
        gp_amount: null,
        gp_standard: null,
        commission_rate: null,
        product_remark: null,
        vendor_type: null,
        cost_promotion_exclude_vat: null,
        promotion_start_date: moment()
          .startOf('day')
          .format('YYYY-MM-DDTHH:mm'),
        promotion_end_date: moment()
          .endOf('day')
          .format('YYYY-MM-DDTHH:mm'),
        promotion_status: StatusEnum.ACTIVE,
      }
      this.isValidate.promotion_date = false
    },
    onClearCondition() {
      // this.productItems = []
      this.searchProductCondition = null
      this.filter.keyword = ''
      this.filter.promotion_start_date = ''
      this.filter.promotion_end_date = ''
    },
    onDeleteProduct(id) {
      this.productItems.splice(
        this.productItems.findIndex(element => element.id === id),
        1
      )
    },
    onDownloadTemplate() {
      const dataWS = XLSX.utils.json_to_sheet(this.exportData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, this.templateName)
    },
    async importExcel(e) {
      var vm = this
      var selectedFile = e.target.files[0]
      var reader = new FileReader()
      reader.onload = function(event) {
        var items = []
        var data = event.target.result
        var workbook = XLSX.read(data, {
          type: 'binary',
        })
        workbook.SheetNames.forEach(function(sheetName) {
          var row = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[sheetName]
          )
          let headers = [
            'รหัสสินค้า (OFM)',
            'ราคาทุนโปรโมชั่น ExVat',
            'วันที่เริ่มต้น',
            'วันที่สิ้นสุด',
            'หมายเหตุการปรับราคาทุนโปรโมชั่น',
          ]
          let j = 0
          for (let key in row[0]) {
            if (
              key !== headers[j] &&
              key !== null &&
              key !== undefined &&
              key !== ''
            ) {
              // vm.fileName = ''
              vm.items = []
              // vm.Response('500', 'Format ของ File Excel ผิดรูปแบบ', '', 'Error')
              vm.$utils.notification(
                'error',
                'Format ของ File Excel ผิดรูปแบบ',
                3000
              )
              return
            }
            j++
          }
          for (let i = 0; i < row.length; i++) {
            if (
              !(
                (row[i]['รหัสสินค้า (OFM)'] === '' ||
                  row[i]['รหัสสินค้า (OFM)'] === null ||
                  row[i]['รหัสสินค้า (OFM)'] === undefined) &&
                (row[i]['ราคาทุนโปรโมชั่น ExVat'] === '' ||
                  row[i]['ราคาทุนโปรโมชั่น ExVat'] === null ||
                  row[i]['ราคาทุนโปรโมชั่น ExVat'] === undefined) &&
                (row[i]['วันที่เริ่มต้น'] === '' ||
                  row[i]['วันที่เริ่มต้น'] === null ||
                  row[i]['วันที่เริ่มต้น'] === undefined) &&
                (row[i]['วันที่สิ้นสุด'] === '' ||
                  row[i]['วันที่สิ้นสุด'] === null ||
                  row[i]['วันที่สิ้นสุด'] === undefined) &&
                (row[i]['หมายเหตุการปรับราคาทุนโปรโมชั่น'] === '' ||
                  row[i]['หมายเหตุการปรับราคาทุนโปรโมชั่น'] === null ||
                  row[i]['หมายเหตุการปรับราคาทุนโปรโมชั่น'] === undefined)
              )
            ) {
              items.push({
                sku_code_ofm: row[i]['รหัสสินค้า (OFM)'],
                cost_promotion_exclude_vat: row[i]['ราคาทุนโปรโมชั่น ExVat'],
                promotion_start_date: row[i]['วันที่เริ่มต้น'],
                promotion_end_date: row[i]['วันที่สิ้นสุด'],
                product_remark: row[i]['หมายเหตุการปรับราคาทุนโปรโมชั่น'],
              })
            }
          }
        })
        vm.onUpload(items)
        // vm.fileName = selectedFile.name
      }
      reader.onerror = function(event) {
        if (event.target.error.name === 'NotReadableError') {
          alert("Canno't read file !")
        }
      }
      reader.readAsBinaryString(selectedFile)
    },
    onClearRowDataError() {
      this.productItems = this.productItems.filter(f => f.is_error == false)
    },
    async onPromotionStatusSelector(data) {
      this.isValidate.promotion_status = false
      this.reloadPromotionStatusSelector = false
      this.model.promotion_status = data.text ? data.text : ''
    },
    async onPromotionStatusSelectorInConditionList(data, index) {
      this.reloadPromotionStatusSelector = false
      this.productItems[index].promotion_status = data.text ? data.text : ''
    },
    async onCheckExistProductCostPromotion() {
      if (
        this.model.promotion_start_date !== null &&
        this.model.promotion_start_date !== undefined &&
        this.model.promotion_end_date !== null &&
        this.model.promotion_end_date !== undefined
      ) {
        let params = new URLSearchParams()
        params.append('sku_id', this.model.id)
        if (this.mode == 'edit') {
          params.append(
            'product_sku_promotion_price_id',
            this.model.product_sku_promotion_price_id
          )
        }
        params.append('mode', this.mode)
        params.append('promotion_start_date', this.model.promotion_start_date)
        params.append('promotion_end_date', this.model.promotion_end_date)

        let result = await productCostPromotionService.headProductCostPromotionAsync(
          params
        )
        if (result.status === 200) {
          this.isValidate.promotion_date = true
          this.$utils.notification(
            'error',
            'มีการกำหนดราคาทุนโปรโมชั่นในช่วงเวลานี้ในระบบแล้ว',
            2000
          )
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.promotion_date = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
  },
}
</script>
